import { request } from 'graphql-request';
import { API_URL, APP_DOMAIN } from 'appenv';

const fetchAllParticipantsQuery = `
  query fetchAllParticipants(
    $domain: String!,
    $afterCursor: String,
    $keyword: String,
    $limit: Int,
  ) {
    eventByDomain(domain: $domain) {
      attendeesByKeyword(
        keyword: $keyword
        first: $limit,
        after: $afterCursor
      ) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            firstName
            lastName
            name
            customAttendeeFields
            uuid
            vexpoChatTag
            vexpoChatUserDescription
            company
            enrichment
          }
        }
      }
    }
  }
`;

function fetchAllParticipants(afterCursor, keyword, limit) {
  return request(API_URL, fetchAllParticipantsQuery, {
    domain: APP_DOMAIN,
    afterCursor,
    keyword,
    limit,
  }).then((result) => {
    const { eventByDomain: { attendeesByKeyword } } = result;
    return attendeesByKeyword;
  });
}

export default fetchAllParticipants;
